import EngineCleanupBase from '../../services/engines/EngineCleanupBase';
import { publish } from '../../services/utils/pubsub';
import { events } from '../../services/wss/SystemEvents';
import gatewayService from '../../services/GatewayService';
import quotaEngine from '../../services/engines/QuotaEngine';
import responseHelper from '../../services/ResponseHelper';

const _name = 'UserEngine';

class UserEngine extends EngineCleanupBase {
    _user = null;

    constructor() {
        super();
    }

    // ─── lifecycle ────────────────────────────────────────

    bootup = () => {
        this.initialize(_name);
    };

    clear = () => {
        this._user = null;
        super.clear();
    };

    // ─── called by bootFetchers ───────────────────────────

    /**
     * Fetches the current user from BE via REST.
     * Called once from bootFetchers, after auth + SignalR connection is confirmed.
     * @returns {Promise<true|number|false>} true on success, error code or false on failure
     */
    fetchUser = async () => {
        try {
            // Skip if already loaded — fetchUser should only run once per session
            if (this._user) return true;

            const resp = await gatewayService.getUser();
            const code = responseHelper.check(resp, 'getUser', _name);
            if (code !== 200) {
                this.logError('onRestored', `getUser failed, code=${code}`);
                return code;
            }

            this._user = resp.data;
            quotaEngine.load(this._user?.quota);
            publish(events.onUserLoaded, this._user);
            return true;
        } catch (error) {
            this.logError('fetchUser', error.message);
            return false;
        }
    };

    // ─── public ──────────────────────────────────────────

    /**
     * Returns the cached user object, or null if not yet loaded.
     * @returns {object|null}
     */
    getUser = () => this._user;
}

const userEngine = new UserEngine();
export default userEngine;
